module.exports = __webpack_public_path__ + "static/media/travicar_eletrostatico_PONTEIRA_ceramica.3e6e8a41.png";